<app-page-header [isBack]="false">
	<ng-container titles>Livraison</ng-container>
	<ng-container actions> </ng-container>
</app-page-header>
<!-- Main Form for Filter (formFilter) -->

<div class="card shadow-sm h-100">
	<div class="card-header bg-transparent border-bottom">
		<h5 class="card-title mb-0 text-primary">Filtres</h5>
	</div>
	<div class="card-body">
		<form [formGroup]="formFilter">
			<div class="row gy-2">
				<div class="col-md-4">
					<app-select
						[items]="projets"
						[formControl]="formFilter.get('projet')"
						bindLabel="nom"
						bindValue="id"
						[searchable]="true"
						placeholder="Chantier"
						[clearable]="true"
						filter="filters[isActif]=true"
						(selectionChange)="onSelectProject($event)"
					/>
				</div>
				<div class="col-md-4">
					<app-select
						[items]="[
							{ nom: 'rest', label: 'reste à livrer' },
							{ nom: 'tout', label: 'tout' }
						]"
						[formControl]="formFilter.get('livraison')"
						bindLabel="label"
						bindValue="nom"
						[searchable]="true"
						placeholder="Livraison"
						[clearable]="true"
					/>
				</div>
				<div class="col-md-4">
					<app-select
						[items]="demandesFilter"
						[formControl]="formFilter.get('demande')"
						bindLabel="numero"
						bindValue="id"
						[searchable]="true"
						placeholder="Demande"
						[clearable]="true"
					/>
				</div>
			</div>
		</form>
	</div>
</div>
<br />
<!-- Main Form for Bon de Sortie (formBonSortie) -->

@if (!isDataLoading) {
	@if (articles.length > 0) {
		<div class="card shadow-none">
			<div class="card-body">
				<form [formGroup]="formBonSortie">
					<div class="row" formArrayName="articles">
						<table class="table align-middle table-striped table-hover mb-0 table-wrap">
							<thead>
								<tr class="bg-light text-muted lh-sm">
									<th style="width: 60%">Désignation</th>
									<th style="width: 10%">Qté demandée</th>
									<th style="width: 10%">Qté livrée</th>
									<th style="width: 10%">Reste à livrer</th>
								</tr>
							</thead>
							<tbody>
								@for (article of articlesForm.controls; track $index) {
									<tr class="cursor-pointer">
										<td>
											<span class="fw-medium">
												{{ article?.value.article.code + " - " }}
												<span class="text-info">{{ article.value.article.designation }}</span>
											</span>
										</td>
										<td (click)="openModalDmd($event, content, article.get('demandes').value)">
											<span class="shadow-sm badge rounded-pill fw-medium p-2 bg-secondary-subtle text-secondary">
												{{ article.value.qteDemandee | truncateDecimal }}
											</span>
										</td>
										<td>
											<span
												(click)="openModalBS($event, Sorties, article.get('sorties').value)"
												class="shadow-sm badge rounded-pill fw-medium p-2 bg-success-subtle text-success"
												>{{ article.value.qteLivree }}</span
											>
										</td>
										<td>
											<span class="shadow-sm badge rounded-pill fw-medium p-2 bg-primary-subtle text-primary">{{ article.value.resteALivrer | truncateDecimal }}</span>
										</td>
									</tr>
								}
							</tbody>
						</table>
					</div>
				</form>
			</div>
		</div>
	} @else {
		<div class="text-center justify-content-center align-items-center">Aucun article à livrer trouvé</div>
	}
} @else {
	<app-loading></app-loading>
}
<!-- detail qte Create Model -->
<ng-template #content role="document" let-modal>
	<div class="modal-header bg-light p-3">
		<h4 class="modal-title fw-normal">Détails des quantités par demande</h4>
		<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal" (click)="modal.dismiss('Cross click')"></button>
	</div>
	<div class="modal-body">
		<table class="table align-middle table-striped table-hover">
			<thead>
				<tr class="bg-light text-muted">
					<th style="width: 20%">Numero</th>
					<th style="width: 20%">Qté demandée</th>
					<th style="width: 20%">Qté livrée</th>
					<th style="width: 20%">Reste à livrer</th>
					<th style="width: 20%">Date</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let dmd of demandes; trackBy: dmd">
					<td>
						<a [routerLink]="['/demandes/demande', dmd.id]" target="_blank" class="link-primary fw-medium">#{{ dmd.numero }}</a>
					</td>
					<td>{{ dmd.qteDemandee }}</td>
					<td>{{ dmd.qteLivree }}</td>
					<td>{{ dmd.resteALivrer }}</td>
					<td>{{ dmd.publicationDate | dateFormatPipe }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</ng-template>
<!-- detail Bon Sortie Model -->
<ng-template #Sorties role="document" let-modal>
	<div class="modal-header bg-light p-3">
		<h4 class="modal-title fw-normal">Détails des quantités Bons Storties</h4>
		<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal" (click)="modal.dismiss('Cross click')"></button>
	</div>
	<div class="modal-body">
		<table class="table align-middle table-striped table-hover">
			<thead>
				<tr class="bg-light text-muted">
					<th style="width: 25%">Numero</th>
					<th style="width: 25%">Qté</th>
					<th style="width: 25%">Magasinier</th>
					<th style="width: 25%">Date</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let dmd of sorties; trackBy: dmd">
					<td>{{ dmd.numero }}</td>
					<td>{{ dmd.qte | truncateDecimal }}</td>
					<td>{{ dmd.magasinier }}</td>
					<td>{{ dmd.date | dateFormatPipe }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</ng-template>
